package com.example.mystybag.login.logic

import com.example.mystybag.core.logic.base.NavigatorConfig

/** Optional [initialChild] skips Welcome: e.g. NavigatorMerchantLogin or NavigatorMerchantBiometric() for merchant re-login. */
data class NavigatorFeatureLoginAndRegistration(
    var replaceCounter: Int = 0,
    val initialChild: NavigatorConfig? = null
): NavigatorConfig()

object NavigatorWelcome : NavigatorConfig()

/** Used when user presses Back from login screen; WelcomeViewModel will not auto-navigate to merchant/staff login. */
object NavigatorWelcomeFromBack : NavigatorConfig()


